import React, { useEffect } from "react";
import Header from "../study.plans/common/header";
import StudyPlanSearch from "../study.plan.search";
import { useStudyPlan } from "../app/contexts/study.context";
import { useUser } from "../app/contexts/user.context";
import { useParams, useLocation, Navigate, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import MuiPaper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import StudyActualsTable from "./study.actuals.table";
import StudyActualsRemodel from "./study.actuals.remodel";

const StudyPlanActuals = () => {
  const { id, planId } = useParams();
  const location = useLocation();
  const { fetchStudy, loadingStudy } = useStudyPlan();
  const { isReadOnlyUser, setURLStudyId } = useUser();

  useEffect(() => {
    setURLStudyId(id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    /**
     * This "shouldFetch" is the only way we can detect that the user landed
     * on the table without fetching on every page navigation nested under
     * /ctpo/study-plans/:id/:planId
     *
     * This allows the page to refetch in the list, but also allows for a
     * smooth experience when navigating once we have a planId.
     *
     * This would have been done by checking when planId is null, but useParam
     * sets planId to "undefined" on every navigate.
     */
    const shouldRefetch = (location.pathname.match(/\//g) || []).length === 3;
    if (shouldRefetch) {
      fetchStudy(id);
    }
    // eslint-disable-next-line
  }, [id, location, planId]);

  //Fetch on mount
  useEffect(() => {
    fetchStudy(id);
    // eslint-disable-next-line
  }, []);

  if (loadingStudy) {
    return <LinearProgress />;
  }
  return (
    <Container>
      <StudyPlanSearch hasMargin={false} />
      <Paper>
        <Header />
        <Routes>
          {/* Redirect read-only users from restricted routes */}
          {isReadOnlyUser && (
            <Route
              path="remodel"
              element={<Navigate to={`/ctpo/study-actuals/${id}`} replace />}
            />
          )}
          <Route index element={<StudyActualsTable />} />
          {!isReadOnlyUser && (
            <Route path="remodel" element={<StudyActualsRemodel />} />
          )}
        </Routes>
      </Paper>
    </Container>
  );
};

export default StudyPlanActuals;

const Container = styled.div`
  padding: 1em;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 350px 1fr;
  overflow: hidden;
`;

const Paper = styled(MuiPaper)`
padding: 1em;
overflow: auto;
flex-direction: column;
display: flex;
height: calc(100vh - 93px);
`;
